import { render, staticRenderFns } from "./FormLoading.vue?vue&type=template&id=252f71ac&scoped=true&"
import script from "./FormLoading.vue?vue&type=script&lang=js&"
export * from "./FormLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f71ac",
  null
  
)

export default component.exports